module.exports = __webpack_public_path__ + "img/RedMCCard.efaa8469.png";